/* @flow */
import ListenerManager from '../utilities/ListenerManager';
import {select} from '../utilities/select';
import type {Module} from '../types';

const listeners: ListenerManager = new ListenerManager;

const collapsibleNav: Module = {
  init(): void {
    this.destroy();

    const collapsible: ?HTMLElement = select('.js-collapsible');
    const collapsibleToggle: ?HTMLElement = select('.js-toggle-collapsible');
    const collapsibleContent: ?HTMLElement = select(
      '.c-responsive-nav__collapsible'
    );
    const navbar: ?HTMLElement = select('.c-navbar');

    if (!collapsible) {
      return;
    }

    if (collapsibleToggle) {
      listeners.add(collapsibleToggle, 'click', (e: Event) => {
        e.preventDefault();
        collapsible.classList.toggle('is-open');
        collapsibleToggle.blur();
      });
    }

    if (collapsibleContent) {
      listeners.add(collapsibleContent, 'click', (e: Event) => {
        e.preventDefault();
        collapsible.classList.remove('is-open');
      });
    }

    if (navbar) {
      listeners.add(navbar, 'click', (e: Event) => {
        e.stopPropagation();
      });
    }
  },
  destroy(): void {
    listeners.removeAll();
  }
};

export default collapsibleNav;



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/magazine/collapsibleNav.js